import { render } from "./ActionSection.vue?vue&type=template&id=ff56521a&scoped=true"
import script from "./ActionSection.vue?vue&type=script&lang=js"
export * from "./ActionSection.vue?vue&type=script&lang=js"

import "./ActionSection.vue?vue&type=style&index=0&id=ff56521a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff56521a"]])

export default __exports__